<script>
	import { display } from '../stores';
	import { presets } from '../dispaly_presets';

	export let display_presets = [...presets];
	
	const get_current_display = type => display_presets.find(p => p.type === type);

	// sets CSS vars for easy use in components
	const set_root_css = disp => {
		for (let [prop, value] of Object.entries(disp.values)) {
			document.documentElement.style.setProperty(`--display-${prop}`, value);
		}
		document.documentElement.style.setProperty("--display-name", disp.type);
	};

	// screen checker
	let screen_w;
	$: if (screen_w <= 720) {
		display.set('m');
		set_root_css(get_current_display('m'));
	} else if (screen_w >= 720 && screen_w <= 1000) {
		display.set('t');
		set_root_css(get_current_display('t'));
	} else {
		display.set('d');
		set_root_css(get_current_display('d'));
	};

</script>

<svelte:window bind:innerWidth={screen_w}/>
<slot>
</slot>
